module.exports = __webpack_public_path__ + "img/icon-page-footer-logo.72c63d53.svg";